const getCart = () => {
  let products = [];
  const productsString = localStorage.getItem('products');
  if (productsString) products = JSON.parse(productsString);
  return products;
};

export default getCart;
